import { observer } from 'mobx-react-lite';

import { Badge } from '@components/badge';
import { IconAppExtraSmall } from '@components/icons/app-extra-small';
import { Stack } from '@components/stack';

import { useIntegrationLabels } from 'hooks/use-integration-labels';
import { useStore } from 'models/Provider';
import { IApplication } from 'models/types';

export const ApplicationLabels = observer(({ application }: { application: IApplication }) => {
  const { t } = useStore();
  const isNew = application.userRead && !application.userRead.newApplication;
  const integrationsLabels = useIntegrationLabels(application.integrationsResults);
  return (
    <Stack orientation="horizontal" space={1} wrap>
      {application.referredBy && <Badge variant="blue" text={t('application.label.sourced')} />}
      {application.isNotifiedOfRejection && (
        <Badge variant="red" text={t('application.label.rejectionsent')} />
      )}
      {isNew && <Badge variant="green" text={t('application.label.new')} />}
      {application.isRetracted && (
        <Badge variant="orange" text={t('application.label.retracted')} />
      )}
      {application.isManuallyAdded && (
        <Badge variant="neutral" text={t('application.label.manuallyadded')} />
      )}
      {integrationsLabels?.map((label) => (
        <Badge
          key={label.text}
          variant={label.variant}
          icon={<IconAppExtraSmall />}
          text={label.text}
        />
      ))}
    </Stack>
  );
});
